// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderTotalDisplaySharedStyles } from "@synd/App/SharedStyles/MyAccountPages/Details/OrderTotalDisplaySharedStyles";
import { totalStyles } from "@synd/Overrides/Widgets/InvoiceDetails/InvoiceDetailsTotal";
import { mergeWithCss } from "@synd/XDL/Utilities";

totalStyles.labelGridItem = {
    ...orderTotalDisplaySharedStyles.labelGridItem,
};
totalStyles.valueGridItem = {
    ...orderTotalDisplaySharedStyles.valueGridItem,
};
totalStyles.subtotalLabelText = {
    ...orderTotalDisplaySharedStyles.label,
};
totalStyles.subtotalValueText = {
    ...orderTotalDisplaySharedStyles.value,
};
totalStyles.discountsLabelText = {
    ...orderTotalDisplaySharedStyles.label,
};
totalStyles.discountsValueText = {
    ...orderTotalDisplaySharedStyles.value,
};
totalStyles.shippingAndHandlingLabelText = {
    ...orderTotalDisplaySharedStyles.label,
};
totalStyles.shippingAndHandlingValueText = {
    ...orderTotalDisplaySharedStyles.value,
};
totalStyles.otherChargesLabelText = {
    ...orderTotalDisplaySharedStyles.label,
};
totalStyles.otherChargesValueText = {
    ...orderTotalDisplaySharedStyles.value,
};
totalStyles.taxLabelText = {
    ...orderTotalDisplaySharedStyles.label,
};
totalStyles.taxValueText = {
    ...orderTotalDisplaySharedStyles.value,
};
totalStyles.totalLabelText = {
    ...orderTotalDisplaySharedStyles.totalLabel,
};
totalStyles.totalValueText = {
    ...orderTotalDisplaySharedStyles.totalValue,
};

totalStyles.container = {
    ...mergeWithCss(orderTotalDisplaySharedStyles.mainContainer, orderTotalDisplaySharedStyles.wrapper),
};
totalStyles.fullWidthGridItem = {
    width: 12,
};
totalStyles.invoiceSummaryLabel = {
    ...orderTotalDisplaySharedStyles.titleText,
};
totalStyles.styledHr = {
    ...orderTotalDisplaySharedStyles.styledHr,
};
